// used when we want to extend a styled components className with the attrs method
// example:
// styled.div.attrs(({ className }) => withExtendedClass({ className, extended: 'costumClass' }))`
// result 'costumClass sc-ckVGcZ cUEZSI'

export const withExtendedClass = ({ className, extend }) => ({
  className: `${extend || ""} ${(className && className) || ""}`.trim()
});
